import {SubmissionRepository} from '../../../repositories/submission.repository';
import * as Model from '../../../models/models';
import _ = require('lodash');
import {Constants} from '../../../models/constants/marketplace.constants';
import SubmissionStatus = Constants.SubmissionStatus;
import { AuthenticationService } from '../../../authentication/authentication.service';

export enum UserAccountState {
    newOrQuoteInProgress,
    quotedOrReferred,
    bound
}

export class UserAccountStateService {
    public static $inject = ['$q', 'submissionRepository', 'authenticationService'];

    constructor(private $q: ng.IQService,
                private submissionRepo: SubmissionRepository,
                private authenticationService: AuthenticationService) {
    }

    public getUserState(): ng.IPromise<UserAccountState> {
        if (!this.authenticationService.isAuthenticated()) {
            return this.$q.when(UserAccountState.newOrQuoteInProgress);
        }
        // there's a party id, get their submissions
        return this.submissionRepo.getCurrentUsersSubmissions().then((submissions: Model.ISubmission[]) => {
            if (!_.some(submissions)) {
                // no submissions means a new user or existing user in progress
                return UserAccountState.newOrQuoteInProgress;
            }
            if (_.some(submissions, (item) => item.statusCId === SubmissionStatus.Bound.toString())) {
                return UserAccountState.bound;
            }
            // if they have submissions but they are not bound, we will default them for now to the "quoted or referred" state so they will see the info page
            //  regardless of what the submission status is
            return UserAccountState.quotedOrReferred;
        });
    }
}